import React, { createContext, useContext } from 'react'
import { Country } from '../../../../core/models/entities/Country'

export interface CountryProviderContext {
  countries: Country[]
}

const CountryContext = createContext<CountryProviderContext | undefined>(undefined)

interface CountryProviderProps {
  children: React.ReactNode
  countries: Country[]
}

function CountryProvider({
  children,
  countries: o
}: CountryProviderProps): React.ReactElement {
  // Follow the prop instead of snapshotting it in state: the app now renders while
  // countries load in the background (non-blocking preload), so late-arriving data
  // must propagate to consumers (country dropdowns) instead of being frozen at mount.
  return (
    <CountryContext.Provider
      value={{ countries: o }}>
      {children}
    </CountryContext.Provider>
  )
}

function useCountryContext() {
  const context = useContext(CountryContext)
  if (!context) {
    throw new Error('useCountryContext must be used within a RepositoriesProvider')
  }

  return context
}


export { CountryProvider, useCountryContext, CountryContext }